<ng-content select="[above-calendar]" />

<optimizer-calendar
  [address]="address()"
  [mock]="mock()"
  [compact]="compact()"
  [leases]="leases"
  [showPricing]="showPricing()"
  [interactive]="interactive()"
  (cellClick)="onCellClick($event)" />

<div class="rs-block">
  <div class="rs-bar">
    <div class="rs-legend">
      <span class="rs-legend__swatch rs-legend__swatch--available" aria-hidden="true"></span>
      <tidy-text [helper]="'Available'" class="rs-legend__label" />
      <span class="rs-legend__swatch rs-legend__swatch--booked" aria-hidden="true"></span>
      <tidy-text [helper]="'Booked'" class="rs-legend__label" />
      <span class="rs-legend__swatch rs-legend__swatch--blocked" aria-hidden="true"></span>
      <tidy-text [helper]="'Blocked'" class="rs-legend__label" />
    </div>

    <div class="rs-actions">
      <tidy-text
        class="white-link rs-actions__add"
        [actionBody]="'+ Block dates'"
        (action)="openBlockDates()" />
    </div>
  </div>
</div>
